import { render, staticRenderFns } from "./MaxBonuses.vue?vue&type=template&id=7c5d3c62&"
import script from "./MaxBonuses.vue?vue&type=script&lang=js&"
export * from "./MaxBonuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports